<template>
    <div>
        <div class="flex-y-center radio-wrap">
            <label class="radiobox">
                <input type="checkbox" class="normal-radio icon-round-check" name="normalcharging" value="emarticonTerms"/>
                <span>이마티콘 이용약관(필수)</span>
            </label>
        </div>
        <div class="terms-gray-box">
            <span>이마티콘 이용동의</span>
            <button>보기</button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TermsBox',
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/common/termsBox.scss';
</style>